import React, { useEffect, useState } from "react";
import { Table, Image } from "react-bootstrap";
import Pagination from "@material-ui/lab/Pagination";
import { connect } from "react-redux";
import DeleteWarningModal from "../../common/modal/delete-warning-modal";
import EditOrganization from "./edit-organization";
import RemoveOrganization from "./remove-organization";
import { listOrganization } from "../../../crud/organization.crud";
import { toAbsoluteUrl } from "../../../../_metronic/utils/utils";
import NoDataFound from "../../../components/NoDataFound";
const OrganizationList = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    skip: 0,
    limit: 5,
    total: 0,
    totalPage: 0,
  });

  const [page, setPage] = useState(1);
  const [showOrganizationEdit, setShowOrganizationEdit] = useState(false);
  const [selectedData, setSelectedData] = useState();
  const [showOrganizationDelete, setShowOrganizationDelete] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);

  useEffect(() => {
    reloadList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.data.organization.listData) {
      let listObject = {
        data: [...props.data.organization.listData.data.data.data],
        skip: tableData.skip,
        limit: tableData.limit,
        total: props.data.organization.listData.data.data.total,
        totalPage: Math.ceil(
          Number(
            props.data.organization.listData.data.data.total / tableData.limit
          )
        ),
      };
      setTableData({
        ...tableData,
        ...listObject,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data.organization.listData]);

  useEffect(() => {
    setUserInfo(props.data.account.user);
  }, [props.data.account.user]);

  const reloadList = () => {
    listOrganization({ skip: tableData.skip, limit: tableData.limit }).then(
      (docs) => {
        if (docs.data) {
          setTableData({
            data: [...docs.data.data.data],
            skip: tableData.skip,
            limit: tableData.limit,
            total: 0,
            totalPage: Math.ceil(
              Number(docs.data.data.total / tableData.limit)
            ),
          });
        }
      }
    );
  };

  const handleChange = (_event, value) => {
    setPage(value);

    listOrganization({
      skip: Number((value - 1) * tableData.limit),
      limit: tableData.limit,
    }).then((docs) => {
      // console.log(docs);
      let listObject = {
        data: [...docs.data.data.data],
        skip: Number((value - 1) * tableData.limit),
        limit: tableData.limit,
        total: docs.data.data.total,
        totalPage: Math.ceil(Number(docs.data.data.total / tableData.limit)),
      };
      //   console.log("listObject", listObject);
      setTableData({
        ...tableData,
        ...listObject,
      });
    });
  };

  const handleCloseEdit = () => {
    setShowOrganizationEdit(false);
  };

  const handleCloseDelete = () => {
    setShowOrganizationDelete(false);
  };

  const openEditModal = (data) => {
    setSelectedData(data);
    setShowOrganizationEdit(true);
  };

  const openDeleteModal = (data) => {
    if (userInfo.roleInfo.isSuperAdmin) {
      setSelectedData(data);
      setShowOrganizationDelete(true);
    } else {
      setShowDeleteWarning(true);
    }
  };

  return (
    <React.Fragment>
      {showOrganizationEdit ? (
        <EditOrganization
          organization={selectedData}
          show={showOrganizationEdit}
          handleClose={handleCloseEdit}
        />
      ) : null}
      {showOrganizationDelete ? (
        <RemoveOrganization
          organization={selectedData}
          show={showOrganizationDelete}
          handleClose={handleCloseDelete}
        />
      ) : null}
      {showDeleteWarning ? (<DeleteWarningModal title={'organization'} open={showDeleteWarning} handleClose={() => setShowDeleteWarning(false)} />) : null}
      {tableData.data.length ? (
        <React.Fragment>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>SL No</th>
                <th>Profile Picture</th>
                <th>Name</th>
                <th>Email</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {tableData.data.map((eachData, key) => {
                return (
                  <tr key={eachData._id}>
                    <td>{eachData._id}</td>
                    <td style={{ textAlign: "center" }}>
                      {eachData.personalInfo.profilePicture ? (
                        <Image
                          alt={`user logo`}
                          src={eachData.personalInfo.profilePicture}
                          style={{
                            height: "120px",
                          }}
                        />
                      ) : (
                          <Image
                            alt={`user logo`}
                            src={toAbsoluteUrl(
                              `/media/default-image/default-image.png`
                            )}
                            style={{
                              height: "120px",
                            }}
                          />
                        )}
                    </td>
                    <td>{eachData.personalInfo.name}</td>
                    <td>{eachData.personalInfo.email}</td>
                    <td>
                      <p
                        className="btn btn-sm btn-clean btn-icon btn-icon-md"
                        onClick={() => openEditModal(eachData)}
                        style={{
                          margin: "0",
                        }}
                      >
                        <i className="la la-edit"></i>
                      </p>

                      <p
                        className="btn btn-sm btn-clean btn-icon btn-icon-md deleteProfessionalBtn"
                        title="Delete"
                        style={{
                          margin: "0",
                        }}
                        onClick={() => {
                          openDeleteModal(eachData);
                        }}
                      >
                        <i className="la la-trash kt-font-danger"></i>
                      </p>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          <Pagination
            count={tableData.totalPage}
            color="primary"
            page={page}
            onChange={handleChange}
          />
        </React.Fragment>
      ) : (
        <NoDataFound/>
        )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return { data: state };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationList);
